import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.form,
    rules: _ctx.rules,
    "label-position": "top",
    ref: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.name')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.description')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.form.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.description) = $event)),
            maxlength: "20",
            "show-word-limit": "",
            type: "text"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.station')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _ctx.form.station,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.station) = $event)),
            "value-key": "id",
            filterable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('label.noStation'),
                value: null
              }, null, 8, ["label"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}